module.exports = __webpack_public_path__ + "img/napoli.fe1415e5.svg";